import React from 'react';

const testimonials = [
  {
    name: "Jean Henry",
    jobTitle: "DSI",
    organization: "Groupe Santé",
    text: "PulseCIO a transformé notre gestion de la communication IT. On a réduit de 3 outils à 1, tout en gagnant en traçabilité et en efficacité. Nous avons économisé plus de 200€/mois, un vrai plus pour notre budget et notre efficacité.",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    rating: 5
  },
  {
    name: "Sophie Martin",
    jobTitle: "Directrice",
    organization: "Association Solidaire",
    text: "En tant qu'association, on cherchait un outil abordable pour coordonner nos équipes. PulseCIO nous permet de gérer messages, tâches et rappels sans exploser notre budget. C'est exactement ce qu'il nous fallait!",
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    rating: 5
  },
  {
    name: "Olivier Bernard",
    jobTitle: "Gérant",
    organization: "PME Tech",
    text: "On a économisé plus de 500€/mois en remplaçant Notion, ClickUp et Confluence. PulseCIO est devenu notre hub central. Simple, efficace et adapté à notre taille.",
    avatar: "https://randomuser.me/api/portraits/men/54.jpg",
    rating: 4
  }
];

const schemaData = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "PulseCIO",
  "applicationCategory": "BusinessApplication",
  "operatingSystem": "Web",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "reviewCount": "3",
    "bestRating": "5",
    "worstRating": "1"
  },
  "review": testimonials.map(t => ({
    "@type": "Review",
    "author": {
      "@type": "Person",
      "name": t.name,
      "jobTitle": t.jobTitle
    },
    "reviewBody": t.text,
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": String(t.rating),
      "bestRating": "5",
      "worstRating": "1"
    }
  }))
};

const Testimonials = () => (
  <section id="testimonials" className="py-20 bg-white dark:bg-gray-900" aria-label="Témoignages clients">
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
    />
    <div className="container mx-auto px-6">
      <h2 className="text-3xl font-bold mb-8 text-center">Ils ont choisi PulseCIO</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {testimonials.map((t, i) => (
          <div key={i} className="rounded-lg shadow-lg p-6 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 flex flex-col items-center text-center">
            <img src={t.avatar} alt={`${t.name}, ${t.jobTitle} ${t.organization}, client de PulseCIO`} width="64" height="64" className="w-16 h-16 rounded-full mb-4 border-2 border-blue-400" loading="lazy" />
            <p className="text-gray-700 dark:text-gray-200 mb-4 italic">"{t.text}"</p>
            <span className="font-semibold text-blue-700 dark:text-blue-300">{t.name}</span>
            <span className="text-sm text-gray-500 dark:text-gray-400">{t.jobTitle}, {t.organization}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;